import { Component } from 'preact';
import styled from 'styled-components';

class OurStudio extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}

	render() {
		
		const OurStudioContainer = styled.div`
			background: white;
			display: flex;
			height: 40rem;
			overflow: hidden;
			@media only screen and (max-width: 680px) {
				flex-direction: column;
				height: auto;
			}
			.studio-photo {
				width: 50%;
				@media only screen and (max-width: 680px) {
					width: 100%;
				}
				img {
					object-fit: cover;
					width: 100%;
					height: 100%;
				}
			}
			.studio-about {
				align-items: center;
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 0 2rem;
				width: 50%;
				@media only screen and (max-width: 680px) {
					width: 100%;
					padding: 2rem;
				}
				h3 {
					color: ${this.context.colors.copy};
					font-family: ${this.context.branding.headerFont};
					font-size: 4.8rem;
					margin: 0;
					text-align: center;
					text-transform: uppercase;
					@media only screen and (max-width: 680px) {
						font-size: 3rem;
					}
				}
				p {
					color: ${this.context.colors.copy};
					font-size: 1.4rem;
					line-height: 1.75;
					max-width: 50rem;
					text-align: center;
					width: 100%;
				}
			}
		`;

		return (
			<OurStudioContainer id="studio">
				<div className="studio-photo">
					<img src={this.context.branding.studioPhoto} alt={this.context.copy.longName} />
				</div>
				<div className="studio-about">
					<h3>Who We Are</h3>
					<p>{this.context.copy.aboutCopy}</p>
				</div>
			</OurStudioContainer>
		);
	}
}

export default OurStudio;


// WEBPACK FOOTER //
// ./components/OurStudio.js